export default __webpack_public_path__ + "src/images/packages/villa-54-victoria/8ec3986b1c930d5c80d1253334fb0995-3.jpg";